// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scrolling Banner Styles */
.scrolling-banner {
  background-color: var(--color-primary);
  padding: 0.75rem 0;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  width: 100%;
  box-sizing: border-box;
}

.scrolling-banner-content {
  width: 100%;
  overflow: hidden;
}

.scrolling-banner-text {
  font-family: var(--font-family-scrolling);
  color: var(--color-white);
  font-weight: 400;
  font-size: 1.3rem;
  letter-spacing: 1px;
  text-transform: uppercase;
}

/* Responsive Design */
@media (max-width: 768px) {
  .scrolling-banner-text {
    font-size: 1.2rem;
  }
}

@media (max-width: 480px) {
  .scrolling-banner-text {
    font-size: 1rem;
  }
}

.newsletter-section-spacer {
    width: 100%;
    height: 2rem;
    background-color: var(--color-secondary);
  }`, "",{"version":3,"sources":["webpack://./src/components/ScrollingBanner/ScrollingBanner.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wCAAwC;EAC1C","sourcesContent":["/* Scrolling Banner Styles */\n.scrolling-banner {\n  background-color: var(--color-primary);\n  padding: 0.75rem 0;\n  overflow: hidden;\n  white-space: nowrap;\n  position: relative;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.scrolling-banner-content {\n  width: 100%;\n  overflow: hidden;\n}\n\n.scrolling-banner-text {\n  font-family: var(--font-family-scrolling);\n  color: var(--color-white);\n  font-weight: 400;\n  font-size: 1.3rem;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .scrolling-banner-text {\n    font-size: 1.2rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .scrolling-banner-text {\n    font-size: 1rem;\n  }\n}\n\n.newsletter-section-spacer {\n    width: 100%;\n    height: 2rem;\n    background-color: var(--color-secondary);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
